sf.ready(function() {

    var slideMain = document.querySelector('.slider-main');
    var slideHistory = document.querySelector('.slider-history');

    new Slider(slideMain);
    new Slider(slideHistory);

});